module.exports = __webpack_public_path__ + "static/media/editInput.ee3cf12c.svg";